import { lazy, Suspense } from 'react';
import { Layout } from 'components/themes/v1';

const JobDetail = lazy(() => import('modules/job/JobDetail'));

const JobDetailPage = (props) => (
  <Layout>
    <Suspense fallback={null}>
      <JobDetail />
    </Suspense>
  </Layout>
);

export default JobDetailPage;
